{
  "myList": {
    "title": "MY SPACES",
    "createButton": "+ create space",
    "defaultProductType": "Project",
    "roleMember": "member",
    "searchPlaceholder": "Search spaces...",
    "noSpacesFound": "No spaces found"
  },
  "dashboard": {
    "changeLogoTooltip": "Change Logo",
    "namePlaceholder": "Space Name",
    "descriptionPlaceholder": "Add a description...",
    "editSpaceButton": "Edit space",
    "generated": "Created",
    "timezone": "Timezone",
    "language": "Language",
    "visibility": "Visibility",
    "visibilityPrivate": "Private",
    "visibilityPublic": "The world sees us",
    "unknownDate": "Unknown",
    "membersTitle": "MEMBERS ({{count}})",
    "searchMemberPlaceholder": "Search member...",
    "addGuestsButton": "+ Add guests",
    "detailsTitle": "SPACE DETAILS",
    "spaceType": "Space type",
    "industry": "Industry",
    "plan": "Plan",
    "storage": "Storage",
    "storageUsedPercent": "{{percent}}% used",
    "taskCount": "Number of tasks",
    "docCount": "Documents",
    "creationDate": "Creation date",
    "recentActivityTitle": "RECENT ACTIVITY",
    "noRecentActivity": "No recent activity.",
    "noDetail": "No detail",
    "defaultProductType": "Project",
    "defaultVisibility": "Private",
    "defaultIndustry": "General",
    "defaultPlan": "Enterprise"
  },
  "settingsMenu": {
    "subtitle": "Space settings",
    "general": {
      "title": "General",
      "subtitle": "Basic space information"
    },
    "members": {
      "title": "Members and permissions",
      "subtitle": "Users and roles"
    },
    "safe": {
      "title": "Security",
      "subtitle": "Authentication and sessions"
    },
    "integrations": {
      "title": "Integrations",
      "subtitle": "Connect your tools"
    },
    "ai": {
      "title": "AI and automations",
      "subtitle": "Models, agents, and flows"
    },
    "template": {
      "title": "Appearance",
      "subtitle": "Theme, colors and branding"
    },
    "notifications": {
      "title": "Notifications",
      "subtitle": "Channels and preferences"
    },
    "storage": {
      "title": "Storage",
      "subtitle": "Usage and configuration"
    },
    "billing": {
      "title": "Billing and payments",
      "subtitle": "Plan, payments, and usage"
    },
    "dangerzone": {
      "title": "Danger zone",
      "subtitle": "Delete or transfer space"
    }
  }
}